import { render, staticRenderFns } from "./UBanner.vue?vue&type=template&id=bbdb113c&"
import script from "./UBanner.vue?vue&type=script&lang=js&"
export * from "./UBanner.vue?vue&type=script&lang=js&"
import style0 from "./UBanner.vue?vue&type=style&index=0&id=bbdb113c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports